import React from "react";
import PolygonMapTooltip from "../../components/PolygonMapTooltip";
import NearbyLocationMapTooltip from "../../components/NearbyLocationMapTooltip";
import WardMapTooltip from "../../components/WardMapTooltip";
import ExternalRetailDemandTooltip from "../../components/ExternalRetailDemandTooltip";
import TrafficCountingPointTooltip from "../../components/TrafficCountingPointTooltip";

type MapToolTipsProps = {
  state: any;
};

const MapToolTips = ({ state }: MapToolTipsProps) => {
  const {
    planningPolygonHoveredObject,
    pointerX,
    pointerY,
    nearbyLocationHoveredObject,
    wardHoveredObject,
    externalRetailDemandHoveredObject,
    trafficCountingPointHoveredObject,
  } = state;
  return (
    <>
      {planningPolygonHoveredObject && (
        <PolygonMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={planningPolygonHoveredObject.properties}
        />
      )}
      {nearbyLocationHoveredObject && (
        <NearbyLocationMapTooltip
          onCloseButtonClick={() => {}}
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={nearbyLocationHoveredObject}
        />
      )}
      {wardHoveredObject && (
        <WardMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={wardHoveredObject}
        />
      )}
      {externalRetailDemandHoveredObject && (
        <ExternalRetailDemandTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={externalRetailDemandHoveredObject}
        />
      )}
      {trafficCountingPointHoveredObject && (
        <TrafficCountingPointTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={trafficCountingPointHoveredObject}
        />
      )}
    </>
  );
};

export default MapToolTips;
